import { Skeleton } from '@common/components';
import { SvgBookmark } from '@common/icon';
import { cn } from '@core/utils';

import CommentIcon from '@/assets/svgs/comment_off.svg';

export interface NewsCardFooterProps {
  commentCount?: number;
  isBookmarked?: boolean;

  onClickBookmark?: () => void;
  onClickComment?: () => void;
  isLoading?: boolean;
  className?: string;
}

export const NewsCardFooter = ({
  commentCount = 0,
  isBookmarked,

  onClickComment,
  onClickBookmark,
  isLoading,
  className,
}: NewsCardFooterProps) => {
  return (
    <footer className={cn('flex justify-between gap-8', className)}>
      {isLoading ? (
        <Skeleton className="h-20 w-100" />
      ) : (
        <section className="flex items-center justify-end gap-12 text-[0.75rem] text-Gray-700">
          <button
            className="flex h-fit flex-1 gap-6 p-0 text-[0.75rem] font-400 text-Gray-700"
            type="button"
            onClick={onClickComment}
          >
            <CommentIcon className="size-20 text-Gray-500 transition-[color,fill] duration-200 ease-in-out" />
            {commentCount.toLocaleString()}
          </button>
        </section>
      )}
      <button
        aria-label={isBookmarked ? '북마크 제거' : '북마크 추가'}
        className="flex h-fit cursor-pointer items-center p-0"
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClickBookmark?.();
        }}
      >
        {isLoading ? (
          <Skeleton className="size-20" />
        ) : (
          <SvgBookmark
            className={cn(
              'size-20 text-Gray-500 transition-[color,fill] duration-200 ease-in-out',
              isBookmarked && 'text-black [fill:black]',
            )}
          />
        )}
      </button>
    </footer>
  );
};
